import SSPContentVO from 'sspcontentext/dist/model/SSPContentVO';

function SortTiles(array: SSPContentVO[]) {
    return array.sort((a, b) => a.asModel.integer('DisplayPriority') - b.asModel.integer('DisplayPriority'));
}

export default SortTiles;
